import { useQuery } from '@tanstack/react-query';
import { fetchEvents } from '../api/events';
import { Event } from '../types/events';
import { isCurrentlyActive } from '@/lib/date-utils';

export function useEvents() {
  return useQuery<Event[]>({
    queryKey: ['events'],
    queryFn: async () => {
      const response = await fetchEvents();
      // Filter to only return events that are currently active
      return response.data.filter((event) =>
        isCurrentlyActive(event.EventStartDate, event.EventEndDate)
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}





